import { render, staticRenderFns } from "./modifyListInventoies.vue?vue&type=template&id=0fcf375e&scoped=true"
import script from "./modifyListInventoies.vue?vue&type=script&lang=js"
export * from "./modifyListInventoies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf375e",
  null
  
)

export default component.exports